module.exports = __webpack_public_path__ + "static/media/logo.3213f5b1.png";